module.exports = __webpack_public_path__ + "static/media/enterpriseservices2.c22d3d6e.png";